import {forwardRef, type ReactNode} from 'react';
import {cn} from '../lib/utils';
import {Button, type ButtonProps, type ButtonSize} from '../Button';

export interface IconButtonProps extends Omit<ButtonProps, 'as' | 'children' | 'asChild' | 'fullWidth'> {
	icon: ReactNode;
	'aria-label': string;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(({
	variant = 'ghost',
	size = 'md',
	className,
	...props
}, ref) => (
	<Button
		{...props}
		ref={ref}
		{...{variant, size}}
		data-component='IconButton'
		className={cn(squareStyles[size], className)}/>
));

IconButton.displayName = 'IconButton';

const squareStyles: Record<ButtonSize, string> = {
	sm: 'w-7 px-0',
	md: 'w-8 px-0',
	lg: 'w-10 px-0'
};
